<template>
  <div class="">
    <v-select
      v-model="techniciansList"
      :options="techniciansOptions"
      :clearable="false"
      @input="onChange"
      @search="onSearch"
      multiple
      :disabled="isSelectDisabled"
      :selectable="() => techniciansList.length < maxLength"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    context: Object
  },
  setup(props, { emit }) {
    const search = ref("");
    const limit = ref(8);
    const techniciansList = ref(false);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const maxLength = ref(1);
    const techniciansOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.id,
        label: `${u.employee_id}|${u.first_name}  ${u.last_name} - ${u.company.name}`,
      }))
    );

    onMounted(() => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      techniciansList.value = props.context.model
      maxLength.value = props?.fieldOptions?.fieldTypeCfg?.data[0]?.maxLength || 1
      fetchData()
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          techniciansList.value = newValue
        }
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/employees", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
          },
        });
        options.value = data.data;
      } catch (error) {
        console.error(`Technicians: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      let result = value
      if(value?.length > maxLength.value) {
        result = value.slice(0, maxLength.value);
      }
      props.context.model = result
    }


    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      techniciansList,
      techniciansOptions,
      isSelectDisabled,
      maxLength,
      onSearch,
      onChange
    }
  }
}
</script>
